module.exports = __webpack_public_path__ + "d884f2587b190fd4be9f6d8b9d6e6a22.png";